"use client"

import { useState } from "react"
import { Zap, ArrowRight } from "lucide-react"
import "./SubscriptionExpiredModal.css"

export default function SubscriptionExpiredModal({ show, message, onRedirect }) {
  const [isLoading, setIsLoading] = useState(false)

  const handleRedirect = async () => {
    setIsLoading(true)
    try {
      await onRedirect()
    } finally {
      setIsLoading(false)
    }
  }

  if (!show) return null

  return (
    <div className="subscription-expired-overlay">
      <div className="subscription-expired-container">
        {/* Icon Section */}
        <div className="subscription-expired-icon-wrapper">
          <div className="subscription-expired-icon">
            <Zap size={48} />
          </div>
        </div>

        {/* Content Section */}
        <div className="subscription-expired-content">
          <h2 className="subscription-expired-title">Your Trial Period has Ended</h2>
          {/*<p className="subscription-expired-subtitle">Your free trial has expired</p>*/}

          <div className="subscription-expired-message">
            <p>{message || "Please upgrade your plan to continue using this feature."}</p>
          </div>

          {/* Features List */}
          <div className="subscription-expired-features">
            <div className="subscription-expired-feature-item">
              <span><strong>What do you get?</strong></span>
            </div>
            <div className="subscription-expired-feature-item">
              <span className="subscription-expired-check">✓</span>
              <span>Unlock unlimited access</span>
            </div>
            <div className="subscription-expired-feature-item">
              <span className="subscription-expired-check">✓</span>
              <span>Get advanced analytics</span>
            </div>
            <div className="subscription-expired-feature-item">
              <span className="subscription-expired-check">✓</span>
              <span>Enable team collaboration</span>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <button
          className={`subscription-expired-button ${isLoading ? "loading" : ""}`}
          onClick={handleRedirect}
          disabled={isLoading}
        >
          <span className="subscription-expired-button-text">{isLoading ? "Redirecting..." : "Choose a plan"}</span>
          {!isLoading && <ArrowRight size={20} />}
        </button>
      </div>
    </div>
  )
}
